import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UiOrchestratorService } from '../../core/services/ui-orchestrator.service';
import { RecordDetailConfig, TableData, AccordionItem, ConfigRule } from '../../shared/ui/record-detail-modal/record-detail-modal.types';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { CardModule } from 'primeng/card';
import { StepperModule } from 'primeng/stepper';
import { DialogModule } from 'primeng/dialog';
import { PopoverModule } from 'primeng/popover';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { DrawerModule } from 'primeng/drawer';
import { TooltipModule } from 'primeng/tooltip';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { TagModule } from 'primeng/tag';
import { MessageService } from 'primeng/api';
import { OverlayBadgeModule } from 'primeng/overlaybadge';


import { PageTitleService } from '../../services/page-title.service';


@Component({
  selector: 'app-components',
  standalone: true,
  imports: [
    CommonModule, FormsModule, InputTextModule, TextareaModule, ButtonModule, SelectModule, 
    CheckboxModule, RadioButtonModule, TableModule, AccordionModule, CardModule, StepperModule, 
    DialogModule, PopoverModule, FileUploadModule, ToastModule, DrawerModule, TooltipModule, 
    AvatarModule, BadgeModule, TagModule, OverlayBadgeModule
  ],
  providers: [MessageService],
  templateUrl: './components.component.html'
})
export class ComponentsComponent implements OnInit {
  text: string = '';
  selectedCity: any;
  cities = [
    { name: 'New York', code: 'NY' },
    { name: 'Rome', code: 'RM' },
    { name: 'London', code: 'LDN' }
  ];

  products = [
    { id: '1000', code: 'f230fh0g3', name: 'Bamboo Watch', category: 'Accessories', quantity: 24, inventoryStatus: 'INSTOCK', rating: 5 },
    { id: '1001', code: 'nvklas789', name: 'Black Watch', category: 'Accessories', quantity: 61, inventoryStatus: 'OUTOFSTOCK', rating: 4 },
    { id: '1002', code: 'zz21cz3c1', name: 'Blue Band', category: 'Fitness', quantity: 2, inventoryStatus: 'LOWSTOCK', rating: 3 }
  ];

  visibleDialog: boolean = false;
  visibleDrawerLeft: boolean = false;
  visibleDrawerRight: boolean = false;

  private pageTitleService  = inject(PageTitleService);
  private ui                = inject(UiOrchestratorService);

  constructor(private messageService: MessageService) {}

  ngOnInit() {
    this.pageTitleService.setTitle('Component Gallery');
  }

  showToast(severity: string) {
    this.messageService.add({ severity, summary: 'Action Successful', detail: `You triggered a ${severity} toast!` });
  }

  // ── Record Detail Modal demos ──────────────────────────────────────────

  openEmployeeDemo() {
    const config: RecordDetailConfig = {
      title: 'Ayesha Perera',
      subtitle: 'HR Executive',
      avatar: { name: 'Ayesha Perera' },
      status: { value: 'Active', severity: 'success' },
      width: 'lg',
      tabs: [
        {
          label: 'Personal', icon: 'pi pi-user',
          sections: [
            {
              title: 'Basic Information', icon: 'pi pi-id-card',
              fields: [
                { label: 'Full Name',      value: 'Ayesha Dilnoza Perera',   type: 'text' },
                { label: 'Date of Birth',  value: '1990-04-15',               type: 'date' },
                { label: 'Gender',         value: 'Female',                   type: 'text' },
                { label: 'NIC',            value: '903061234V',               type: 'text' },
                { label: 'Email',          value: 'ayesha.perera@earrow.net', type: 'email' },
                { label: 'Phone',          value: '+94 77 123 4567',          type: 'phone' },
              ]
            },
            {
              title: 'Address', icon: 'pi pi-map-marker',
              fields: [
                { label: 'Street',   value: '45 Galle Road, Colombo 03', type: 'text', span: 'full' },
                { label: 'City',     value: 'Colombo',                   type: 'text' },
                { label: 'Province', value: 'Western',                   type: 'text' },
              ]
            },
          ]
        },
        {
          label: 'Employment', icon: 'pi pi-briefcase',
          sections: [
            {
              title: 'Position', icon: 'pi pi-building',
              fields: [
                { label: 'Department',       value: 'Human Resources', type: 'text' },
                { label: 'Designation',      value: 'HR Executive',    type: 'text' },
                { label: 'Employment Type',  value: 'Permanent',       type: 'badge', severity: 'success' },
                { label: 'Joined Date',      value: '2018-06-01',      type: 'date' },
                { label: 'Probation End',    value: '2018-12-01',      type: 'date' },
                { label: 'Reporting To',     value: 'Kasun Fernando',  type: 'avatar' },
              ]
            },
            {
              title: 'Compensation', icon: 'pi pi-wallet',
              fields: [
                { label: 'Basic Salary', value: 185000,  type: 'currency' },
                { label: 'Pay Grade',    value: 'G-04',  type: 'text' },
              ]
            },
          ]
        },
        {
          label: 'Leave Balance', icon: 'pi pi-calendar',
          sections: [
            {
              title: 'Current Year',
              fields: [
                { label: 'Annual Leave',      value: '8.5',  type: 'number', unit: 'days remaining' },
                { label: 'Casual Leave',      value: '2',    type: 'number', unit: 'days remaining' },
                { label: 'Medical Leave',     value: '14',   type: 'number', unit: 'days remaining' },
                { label: 'No-Pay Leave Used', value: '0',    type: 'number', unit: 'days' },
              ]
            }
          ]
        },
        {
          label: 'Schedule & Policy', icon: 'pi pi-cog',
          sections: [
            {
              title: 'Work Schedule', icon: 'pi pi-calendar',
              fields: [
                {
                  label: 'Weekly Hours',
                  type: 'table',
                  span: 'full',
                  value: {
                    columns: [
                      { key: 'day',   label: 'Day' },
                      { key: 'start', label: 'Start' },
                      { key: 'end',   label: 'End' },
                      { key: 'break', label: 'Break' },
                      { key: 'hours', label: 'Net Hours' },
                    ],
                    rows: [
                      { day: 'Monday',    start: '08:30', end: '17:30', break: '1h', hours: '8h' },
                      { day: 'Tuesday',   start: '08:30', end: '17:30', break: '1h', hours: '8h' },
                      { day: 'Wednesday', start: '08:30', end: '17:30', break: '1h', hours: '8h' },
                      { day: 'Thursday',  start: '08:30', end: '17:30', break: '1h', hours: '8h' },
                      { day: 'Friday',    start: '08:30', end: '17:00', break: '1h', hours: '7.5h' },
                    ],
                  } as TableData,
                },
              ]
            },
            {
              title: 'HR Policies', icon: 'pi pi-book',
              fields: [
                {
                  label: 'Policy Documents',
                  type: 'accordion-list',
                  span: 'full',
                  value: [
                    {
                      title: 'Code of Conduct',
                      content: 'All employees are expected to maintain professional behaviour at all times — respectful communication with colleagues, adherence to the company dress code, and strict compliance with data privacy regulations.',
                    },
                    {
                      title: 'Remote Work Guidelines',
                      content: [
                        'Available to employees with at least 6 months of tenure',
                        'Maximum 2 days per week unless approved by HR',
                        'Core hours 9 AM – 3 PM: must be reachable and online',
                        'Company provides equipment allowance for home office setup',
                        'VPN must be active for all work-related systems access',
                      ],
                    },
                    {
                      title: 'Disciplinary Procedure',
                      content: 'Disciplinary action follows a three-stage process: verbal warning, written warning, and final written warning before termination. HR must be involved from the written warning stage onwards.',
                    },
                  ] as AccordionItem[],
                },
              ]
            },
            {
              title: 'Leave Configuration', icon: 'pi pi-sliders-h',
              fields: [
                {
                  label: 'Active Settings',
                  type: 'config-rules',
                  span: 'full',
                  value: [
                    {
                      label: 'Carry-forward Leave',
                      description: 'Unused annual leave rolls over to the next year (maximum 5 days).',
                      enabled: true,
                    },
                    {
                      label: 'Leave Encashment',
                      description: 'Unused leave balance can be encashed at end of the financial year.',
                      enabled: false,
                    },
                    {
                      label: 'Half-day Applications',
                      description: 'Employees may apply for morning or afternoon half-day leave.',
                      enabled: true,
                    },
                    {
                      label: 'Emergency Leave Override',
                      description: 'Managers can grant emergency leave outside normal annual quotas.',
                      enabled: true,
                    },
                    {
                      label: 'No-Pay Auto Conversion',
                      description: 'Excess leave applications automatically convert to no-pay leave.',
                      enabled: false,
                    },
                  ] as ConfigRule[],
                },
              ]
            },
          ]
        }
      ],
      actions: [
        { label: 'Close', severity: 'secondary', outlined: true, handler: ref => ref?.close() },
      ]
    };
    this.ui.openRecord(config);
  }

  openLeaveDemo() {
    const config: RecordDetailConfig = {
      title: 'Leave Application',
      subtitle: 'LA-00432 · Annual Leave',
      icon: 'pi pi-calendar-times',
      status: { value: 'Pending', severity: 'warn' },
      width: 'md',
      tabs: [
        {
          label: 'Details', icon: 'pi pi-info-circle',
          sections: [
            {
              title: 'Application',
              fields: [
                { label: 'Employee',   value: 'Ruwan Bandara',   type: 'avatar' },
                { label: 'Leave Type', value: 'Annual Leave',    type: 'badge', severity: 'info' },
                { label: 'From Date',  value: '2026-06-20',      type: 'date' },
                { label: 'To Date',    value: '2026-06-24',      type: 'date' },
                { label: 'Duration',   value: 5,                 type: 'number', unit: 'days' },
                {
                  label: 'Reason',
                  value: 'Family vacation for the Perahera festival in Kandy. Will return June 25th.',
                  type: 'long-text',
                  span: 'full'
                },
              ]
            }
          ]
        },
        {
          label: 'Status', icon: 'pi pi-check-circle',
          sections: [
            {
              title: 'Approval',
              fields: [
                { label: 'Status',         value: 'Pending Review', type: 'badge', severity: 'warn' },
                { label: 'Submitted On',   value: '2026-06-13T09:30:00', type: 'datetime' },
                { label: 'Approved By',    value: null,  type: 'text', placeholder: 'Not yet reviewed' },
                { label: 'Approver Note',  value: null,  type: 'text', placeholder: 'None' },
              ]
            }
          ]
        }
      ],
      actions: [
        { label: 'Close',   severity: 'secondary', outlined: true, handler: ref => ref?.close() },
        { label: 'Reject',  icon: 'pi pi-times',   severity: 'danger',  outlined: true, handler: ref => ref?.close() },
        { label: 'Approve', icon: 'pi pi-check',   severity: 'success',                handler: ref => ref?.close() },
      ]
    };
    this.ui.openRecord(config);
  }

  openAppraisalDemo() {
    const config: RecordDetailConfig = {
      title: 'Q1 2026 Appraisal',
      subtitle: 'Ayesha Perera · Self Evaluation',
      icon: 'pi pi-star',
      status: { value: 'In Progress', severity: 'info' },
      width: 'md',
      sections: [
        {
          title: 'Cycle Details', icon: 'pi pi-calendar',
          fields: [
            { label: 'Cycle Name', value: 'Q1 2026',                  type: 'text' },
            { label: 'Period',     value: 'January – March 2026',      type: 'text' },
            { label: 'Template',   value: 'Standard Annual Review',    type: 'text' },
            { label: 'Due Date',   value: '2026-04-15',                type: 'date' },
          ]
        },
        {
          title: 'Overall Score', icon: 'pi pi-chart-bar',
          fields: [
            { label: 'Self Score',     value: '4.2 / 5',  type: 'text' },
            { label: 'Manager Score',  value: null,        type: 'text', placeholder: 'Not yet submitted' },
            { label: 'Final Rating',   value: null,        type: 'text', placeholder: 'Pending completion' },
          ]
        },
        {
          title: 'Comments', icon: 'pi pi-comment', columns: 1,
          fields: [
            {
              label: 'Self Comments',
              value: 'Successfully managed the Q1 recruitment drive, onboarding 12 new employees within target timeline. Key achievements include implementing the new leave policy documentation and coordinating with payroll for the salary revision process.',
              type: 'long-text',
              span: 'full'
            },
            { label: 'Manager Comments', value: null, type: 'text', placeholder: 'Not yet submitted', span: 'full' },
          ]
        },
      ],
      actions: [
        { label: 'Close', severity: 'secondary', outlined: true, handler: ref => ref?.close() },
      ]
    };
    this.ui.openRecord(config);
  }

}